import api from "./api";

const AuthService = {
  // Login com form-urlencoded (igual ao que testaste no Postman)
  login: async (email, password) => {
    const formData = new URLSearchParams({
      email,
      password,
    });

    return api.post(`/auth/login`, formData.toString(), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  },

  // Pedido de acesso (ex: pedido de registo)
  requestAccess: async (formData) => {
    return api.post(`/auth/requestaccess`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // Obter utilizador autenticado por ID
  getUserById: async (userId) => {
    return api.get(`/auth/getuserbyid/${userId}`);
  },

  // Listar todos os utilizadores (apenas admin)
  getAllUsers: async () => {
    return api.get(`/auth/getallusers`);
  },

  // Alterar estado do utilizador (ativo/inativo)
  changeUserStatus: async (userId, activeStatus) => {
    return api.put(`/auth/changeuserstatus/${userId}/${activeStatus}`);
  },

  // Remover utilizador
  removeUser: async (userId) => {
    return api.delete(`/auth/deleteuser/${userId}`);
  },

  // Recuperar password (envia e-mail)
  forgotPassword: async (userMail) => {
    return api.post(`/auth/forgotpassword/${userMail}`);
  },

  // Validar token de recuperação
  validateResetToken: async (resetTokenData) => {
    return api.post(`/auth/validateresettoken/`, resetTokenData);
  },

  // Submeter nova password
  resetPassword: async (resetPasswordRequestData) => {
    return api.post(`/auth/resetpasswordrequest/`, resetPasswordRequestData);
  },
};

export default AuthService;
